import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ApiProvider } from './context/MyContext';
import { RealtimeProvider } from './hooks/comms/RealtimeProvider';
import { RoomsUnreadProvider } from './hooks/comms/RoomsUnreadProvider';
import { CommsNotifyProvider } from './hooks/comms/CommsNotifyProvider';
import { OversightAccessProvider } from './hooks/comms/OversightAccessProvider';
import { ClientProfileProvider } from './common/comms/ClientProfileProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { UtilsProvider } from './context/UtilsContext';
if (process.env.NODE_ENV === 'production') {
  console.error = () => {};
  console.warn = () => {};
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ApiProvider>
      <UtilsProvider>
        <RealtimeProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            {/* OversightAccessProvider sits above RoomsUnreadProvider so the
                unread tracker can read `isStaff` when scoping support tickets. */}
            <OversightAccessProvider>
              <RoomsUnreadProvider>
                <CommsNotifyProvider>
                  <ClientProfileProvider>
                    <App />
                  </ClientProfileProvider>
                </CommsNotifyProvider>
              </RoomsUnreadProvider>
            </OversightAccessProvider>
          </Router>
        </RealtimeProvider>
      </UtilsProvider>
    </ApiProvider>
  </React.StrictMode>
);
